import getParent from '../selectors';

export default state => getParent(state).randomizationHypothesisTesting;
